var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#ffd049",
    d: "M 188.5,31.5 C 239.501,31.3333 290.501,31.5 341.5,32C 347.392,34.8924 351.559,39.3924 354,45.5C 399.167,131.167 444.333,216.833 489.5,302.5C 430.503,303.667 371.503,303.833 312.5,303C 267.539,219.58 222.706,136.08 178,52.5C 176.195,42.7768 179.695,35.7768 188.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#16a05c",
    d: "M 64.5,475.5 C 63.6366,472.077 62.4699,468.744 61,465.5C 60.6174,466.056 60.1174,466.389 59.5,466.5C 39.7389,422.65 19.7389,378.983 -0.5,335.5C -0.5,332.833 -0.5,330.167 -0.5,327.5C 50.6791,244.961 102.346,162.628 154.5,80.5C 183.009,132.181 211.009,184.181 238.5,236.5C 188.469,315.367 138.636,394.367 89,473.5C 83.6811,479.167 77.1811,481.001 69.5,479C 67.6536,477.97 65.9869,476.804 64.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#4486f4",
    d: "M 511.5,345.5 C 511.5,350.833 511.5,356.167 511.5,361.5C 491.362,398.438 471.195,435.438 451,472.5C 448.736,475.433 445.902,477.6 442.5,479C 335.167,479.667 227.833,479.667 120.5,479C 150.833,431.333 181.167,383.667 211.5,336C 308.167,335.333 404.833,335.333 501.5,336C 506.045,338.048 509.378,341.215 511.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.589
    },
    fill: "#05120b",
    d: "M 64.5,475.5 C 62.0743,472.987 60.4076,469.987 59.5,466.5C 60.1174,466.389 60.6174,466.056 61,465.5C 62.4699,468.744 63.6366,472.077 64.5,475.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bb2c7cccc236100909e4698f4d835bf8.svg";
export { ForwardRef as ReactComponent };